import { parse } from 'query-string';

import { RoutesConfig } from '../../RoutesConfig';
import { fetchAdminPages, fetchPreviewPage } from './actions';

export const adminActionCreators = [
  {
    path: RoutesConfig.admin.adminTermsOverview.path,
    exact: true,
    action: fetchAdminPages,
  },
  {
    path: RoutesConfig.admin.previewPageShow.path,
    exact: true,
    action: (
      { versionId, locale }: { versionId: string; locale: string },
      { location: { search } }: { location: Location }
    ) => {
      const genericVersionId = parse(search)['genericVersionId'] as string;

      return fetchPreviewPage(versionId, genericVersionId, locale);
    },
  },
];
